<template>
  <div
    class="w-full h-full flex flex-col justify-center items-center text-center p-16"
  >
    <img src="/assets/tappin-logo.png" class="h-10 w-auto" />
    <h1 class="text-lg font-bold mt-6">
      {{ $t('Views.ResetFallback.title') }}
    </h1>
    <div class="w-full md:w-1/3 mt-5">
      <p>{{ $t('Views.ResetFallback.description') }}</p>
    </div>

    <button
      class="bg-tappin py-2 px-3 rounded text-base mt-4"
      :aria-label="$t('Views.ResetFallback.button')"
      @click="goToLogin"
    >
      {{ $t('Views.ResetFallback.button') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Fallback',
  methods: {
    goToLogin() {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style scoped>
.bg-tappin {
  background-color: #94f7f5;
}
</style>
